import gql from 'graphql-tag';
import * as i0 from "@angular/core";
import * as i1 from "../shared/services/graph-qlclient.service";
export class TipoPagoService {
    constructor(gqlclient) {
        this.gqlclient = gqlclient;
    }
    GetByTipoPago(callback) {
        this.gqlclient.query({
            query: gql `
        query{
          tipo_pago {
            listaTipoPago {
              mensajes {
                codigo
                contexto
                texto
                tipo
              }
              respuesta {
                registros {
                  codigo
                  nombre
                }
              }
            }
          }
        }
        `,
            variables: {},
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.tipo_pago.listaTipoPago;
            callback({ mensajes, respuesta });
        });
    }
}
TipoPagoService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function TipoPagoService_Factory() { return new TipoPagoService(i0.ɵɵinject(i1.GraphQLClient)); }, token: TipoPagoService, providedIn: "root" });
